import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from ".sourceflow/jobs.json";

export const useJobs = ({ filters = {}, limit = 10 } = {}) => {
  const collection = useSourceFlowCollection(data.jobs || []);

  const filtered = Object.entries(filters).length > 0
    ? collection.filter((job) =>
        Object.entries(filters).every(([key, values]) => {
          const categoryId = CATEGORY_IDS[key];
          const category = job.categories.find((cat) => cat.id === categoryId);
          return category?.values.some((val) => values.includes(val.id));
        })
      )
    : collection;

  return limit ? filtered.slice(0, limit) : filtered;
};
